import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { appPath } from '../../../constants';
import ChangeUserPasswordModal from '../../ChangeUserPasswordModal';
import Avatar from '../ui/Avatar';
import ActionsGroup from '../ui/ItemActions';
import _ from 'lodash';
import ErrorMessage from '../../common/forms/ErrorMessage';

export default class FormEmployerDetails extends Component {
  static propTypes = {
    isEditing: PropTypes.bool,
    enableEditingPersonalInfo: PropTypes.func,
    userDetails: PropTypes.object.isRequired,
    handleChangeUser: PropTypes.func.isRequired,
    handleChangeUserPhone: PropTypes.func.isRequired,
    handleChangeSelect: PropTypes.func.isRequired,
    cancelEditingPersonalInfo: PropTypes.func,
    savePersonalInfo: PropTypes.func.isRequired,
    isLoadingPersonalInfo: PropTypes.bool.isRequired,
    handleChangePassword: PropTypes.func,
    company: PropTypes.object,
    department: PropTypes.object,
    errors: PropTypes.object.isRequired
  };

  savePersonalInfo = event => {
    event.preventDefault();
    this.props.savePersonalInfo();
  };

  render () {
    const { isEditing, userDetails, handleChangeUser, handleChangeUserPhone, cancelEditingPersonalInfo,
      enableEditingPersonalInfo, handleChangePassword, company, department, isLoadingPersonalInfo, handleChangeSelect,
      errors } = this.props;
    const { first_name, last_name, email, phone, photo_image_url, department_id } = userDetails;

    const showCompany = !_.isEmpty(company);
    const showDepartments = showCompany && company.departments.length;

    return (
      <form onSubmit={this.savePersonalInfo}>
        <section className='personal-info'>
          <div className='section-header-wrapper justify-content-between w-100'>
            <Avatar photo_image_url={photo_image_url} />
            <ActionsGroup
              isLoading={isLoadingPersonalInfo}
              isEditing={isEditing}
              enterEditMode={enableEditingPersonalInfo}
              exitEditMode={cancelEditingPersonalInfo}
            />
          </div>
          <div className='section-row'>
            <span className='section-row-label'>First Name:</span>
            { isEditing ? (
              <div className='input-wrapper w-100'>
                <input
                  className='input'
                  name='first_name'
                  value={first_name || ''}
                  placeholder='First Name'
                  onChange={handleChangeUser}
                />
                <ErrorMessage errorText={errors.first_name} />
              </div>
            ) : (
              <p>{first_name || ''}</p>
            )}
          </div>
          <div className='section-row'>
            <span className='section-row-label'>Last Name:</span>
            { isEditing ? (
              <div className='input-wrapper w-100'>
                <input
                  className='input'
                  name='last_name'
                  value={last_name || ''}
                  placeholder='Last Name'
                  onChange={handleChangeUser}
                />
                <ErrorMessage errorText={errors.last_name} />
              </div>
            ) : (
              <p>{last_name || ''}</p>
            )}
          </div>
          <div className='section-row'>
            <span className='section-row-label'>Email:</span>
            { isEditing ? (
              <div className='input-wrapper w-100'>
                <input
                  className='input'
                  type='email'
                  name='email'
                  value={email || ''}
                  placeholder='Email'
                  onChange={handleChangeUser}
                />
                <ErrorMessage errorText={errors.email} />
              </div>
            ) : (
              <p>{email || ''}</p>
            )}
          </div>
          <div className='section-row'>
            <span className='section-row-label'>Phone:</span>
            { isEditing ? (
              <div className='input-wrapper w-100'>
                <input
                  className='input'
                  type='tel'
                  name='phone'
                  value={phone || ''}
                  placeholder='Phone'
                  onChange={handleChangeUserPhone}
                />
                <ErrorMessage errorText={errors.phone} />
              </div>
            ) : (
              <p>{phone || ''}</p>
            )}
          </div>

          {showCompany ? (
            <div className='section-row align-center'>
              <span className='section-row-label'>Company:</span>
              <Link className='link-primary' to={`/${appPath}/companies/${company.id}`}>{company.company_name}</Link>
            </div>
          ) : null}

          {showDepartments ? (
            <div className='section-row align-center'>
              {isEditing ? (
                <Fragment>
                  <span className='section-row-label'>Department:</span>
                  <div>
                    <select
                      className={errors.department_id ? 'styled-select employer-editing error-field'
                        : 'styled-select employer-editing'}
                      value={department_id || 0}
                      name='department_id'
                      onChange={handleChangeSelect}
                    >
                      <option value='0'>No Department</option>
                      {company.departments.map(dept =>
                        <option value={dept.id} key={dept.id}>
                          {dept.name}
                        </option>
                      )}
                    </select>
                    <ErrorMessage errorText={errors.department_id} />
                  </div>
                </Fragment>
              ) : (department && department.name) ? (
                <h5><span className='badge badge-secondary'>{department.name}</span></h5>
              ) : (
                <p>No department</p>
              )}
            </div>
          ) : null}

          <div className='w-100'>
            <ChangeUserPasswordModal handleChangePassword={handleChangePassword} />
          </div>
        </section>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/forms/FormEmployerDetails.js